import { render, staticRenderFns } from "./CustomerOdontoImplant.vue?vue&type=template&id=a3f31b46"
import script from "./CustomerOdontoImplant.vue?vue&type=script&lang=js"
export * from "./CustomerOdontoImplant.vue?vue&type=script&lang=js"
import style0 from "./CustomerOdontoImplant.vue?vue&type=style&index=0&id=a3f31b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports